import { Component, Input, OnInit, Output, NgModule } from '@angular/core';
import {OrderListModule} from 'primeng/orderlist';

@Component({
  selector: 'app-edit-column',
  templateUrl: './edit-column.component.html',
  styleUrls: ['./edit-column.component.scss']
})
export class EditColumnComponent implements OnInit {

  @Input() keys = [{}];

  constructor() { }

  // 公用隐藏/显示列
  changeShowColumn(event, res) {
    this.keys.forEach((_key, index) => {
      if (res.key == _key['key']) {
        this.keys[index]['show'] = !this.keys[index]['show'];
      }
    });
  }

  // 公用锁定列
  changeFixColumn(event, res) {
      this.keys.forEach((_key, index) => {
        if (res.key == _key['key']) {
          this.keys[index]['fix'] = !this.keys[index]['fix']
        }
      });
  }

  ngOnInit(): void {}

}

@NgModule({
  imports: [OrderListModule],
  exports: [EditColumnComponent],
  declarations: [EditColumnComponent]
})
export class EditColumnModule { }

